import React, { Component } from 'react';
import { UnmountClosed } from 'react-collapse';

import Icon from './../../components/Icon';

class OrderClientInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(state => Object.assign({}, state, {
            isOpen: !state.isOpen
        }));
    }

    render() {
        const { order, onResize } = this.props;
        const { isOpen } = this.state;

        const clientInfo = order.client_info;
        if (!clientInfo) {
            return null;
        }

        return (
            <div className="order-tab-collapse">
                <div className="order-tab-collapse-head" onClick={this.toggle}>
                    <Icon className="svg-icon" iconName="client-info" />
                    <span className="order-tab-head-name">Client Info</span>
                    {isOpen
                        ? <span className="arrow-down active"></span>
                        : <span className="arrow-down"></span>
                    }
                </div>
                <UnmountClosed isOpened={isOpen} className="order-tab-collapse-body order-client-info" onRender={onResize}>
                <div className="order-tab-content">
                        <div className="row">
                            <div className="col-1">Country of origin</div>
                            <div className="col-1">{clientInfo.country}</div>
                        </div>
                        <div className="row">
                            <div className="col-1">Country of education</div>
                            <div className="col-1">{clientInfo.education_country}</div>
                        </div>
                        <div className="row">
                            <div className="col-1">Gender</div>
                            <div className="col-1">{clientInfo.gender}</div>
                        </div>
                        <div className="row">
                            <div className="col-1">University</div>
                            <div className="col-1">{clientInfo.university}</div>
                        </div>
                        <div className="row">
                            <div className="col-1">Major</div>
                            <div className="col-1">{clientInfo.major}</div>
                        </div>
                        <div className="row">
                            <div className="col-1">Order course</div>
                            <div className="col-1">{clientInfo.course}</div>
                        </div>
                    </div>
                </UnmountClosed>
            </div>
        );
    }
}

export default OrderClientInfo;


// WEBPACK FOOTER //
// ./src/components/order/OrderClientInfo.js